import { resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_installment_state = _resolveComponent("installment-state")
  const _component_installments_progress = _resolveComponent("installments-progress")
  const _component_installments_plan = _resolveComponent("installments-plan")
  const _component_installments_description_box = _resolveComponent("installments-description-box")

  return (_openBlock(), _createBlock(_component_installments_description_box, {
    "number-of-installments": $options.numberOfInstallments,
    "is-notificator-visible": $options.isNotificatorVisible
  }, {
    content: _withCtx(() => [
      _createVNode(_component_installment_state, _normalizeProps(_guardReactiveProps($options.installmentsStateProps)), null, 16 /* FULL_PROPS */),
      _createVNode(_component_installments_plan, _normalizeProps(_guardReactiveProps($options.installmentsPlanData)), {
        default: _withCtx(() => [
          ($options.isInProgressStatus)
            ? (_openBlock(), _createBlock(_component_installments_progress, _mergeProps({ key: 0 }, $options.installmentsProgressProps, { onInstallmentsPaid: $options.onInstallmentsPaid }), null, 16 /* FULL_PROPS */, ["onInstallmentsPaid"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 16 /* FULL_PROPS */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["number-of-installments", "is-notificator-visible"]))
}